export const checkActionPermission = (
  actions: GlobalAction[] | undefined,
  actionId: string,
) => {
  if (!actions) return false;

  return actions.some(
    (action) => action.actionId === actionId && action.enabled === true,
  );
};
